export default __webpack_public_path__ + "fannie-mae-logo-white.png?1bb13d9d252599c682de3614af48bf7d";